<dx-popup
    #workflowMetricsDetails
    minWidth="750px"
    minHeight="150px"
    width="30%"
    height="50%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box id="workflowHistory" width="100%" height="100%" direction="col" class="box-container">
            <dxi-item [ratio]="1">
                <dx-data-grid
                    height="100%"
                    allowColumnResizing="true"
                    [dataSource]="gridSource"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    [hoverStateEnabled]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                >
                    <dxi-column
                        dataField="processDate"
                        dataType="date"
                        caption="Date"
                        [format]="dateFormat"
                    ></dxi-column>
                    <dxi-column dataField="count" dataType="number" caption="Count"></dxi-column>

                    <dxo-summary>
                        <dxi-total-item
                            column="count"
                            name="count"
                            summaryType="sum"
                            dataType="number"
                            displayFormat="Total : {0}"
                        ></dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container">
                        <dx-button
                            type="default"
                            text="Close"
                            [icon]="iconClose"
                            (onClick)="onPopupClose()"
                        ></dx-button>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
